module.exports = __webpack_public_path__ + "static/media/nestjs-logo.429bcad2.png";